export class BreadcrumbComponent implements ng.IComponentOptions {
    public bindings: any = {
        tree: "="
    };
    public controller: any = BreadcrumbController;
    public template: string =
        `<div class="header-lined">
          <ol class="breadcrumb">
            <li ng-repeat="leaf in $ctrl.tree" ng-class="{'active':leaf.active}"><a ng-href="{{leaf.path}}">{{leaf.name}}</a></li>
          </ol>
        </div>
        `;
}
export class BreadcrumbController {

}
